import React from "react";
import { Loader2 } from "lucide-react";
import { useLeads } from "../../hooks/useLeads";
import LeadsToolbar from "./LeadsToolbar";
import LeadsList from "./LeadsList";
import LeadDetail from "./LeadDetail";

const LeadsManager = () => {
  const {
    leads,
    filtered,
    loading,
    active,
    setActive,
    filter,
    setFilter,
    statusFilter,
    setStatusFilter,
    changeStatus,
    remove,
  } = useLeads();

  return (
    <div data-testid="admin-leads-page">
      <LeadsToolbar
        count={leads.length}
        filter={filter}
        setFilter={setFilter}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
      />
      {loading ? (
        <div className="flex items-center justify-center py-20 text-[#0A192F]/40">
          <Loader2 className="animate-spin mr-2" size={18} /> Loading…
        </div>
      ) : (
        <div className="grid lg:grid-cols-5 gap-6">
          <LeadsList
            leads={filtered}
            totalCount={leads.length}
            activeId={active?.id}
            onSelect={setActive}
          />
          <LeadDetail lead={active} onStatusChange={changeStatus} onDelete={remove} />
        </div>
      )}
    </div>
  );
};

export default LeadsManager;
